function ArticlesList({ articles }) {
    return articles?.map((art, index) => <div className='mt-3' key={index}>
        <a href={art.url} target='_blank' rel='noopener noreferrer'>
            <img src={art.thumbnailUrl} width='150px' alt='article thumbnail' />
            <span className='ms-2'>{art.text}</span>
        </a>
    </div>);
}

export default ArticlesList;